<div class="an__filters">
  <div class="an-period" role="group" aria-label="<%= _lcs( 'Zeitraum' ) %>">
    <% periods.forEach( function( p ) { %>
    <button type="button" class="an-period__btn" data-days="<%= p.value %>" aria-pressed="<%= p.active ? 'true' : 'false' %>"><%= p.label %></button>
    <% } ); %>
  </div>
  <span class="an__range"><i class="icon icon--calendar"></i> <%= rangeLabel %></span>
</div>

<section class="kpi-grid">
  <% kpis.forEach( function( k ) { %>
  <div class="kpi">
    <div class="kpi__top">
      <span class="kpi__label"><%= k.label %></span>
      <span class="kpi__icon"><i class="icon icon--<%= k.icon %>"></i></span>
    </div>
    <div class="kpi__value"><%= k.value %></div>
    <span class="kpi__delta kpi__delta--<%= k.noteTone %>"><i class="icon icon--<%= k.noteIcon %>"></i> <span><%= k.note %></span></span>
  </div>
  <% } ); %>
</section>

<% if ( !hasData ) { %>
<section class="widget">
  <div class="widget__body">
    <p class="an-muted"><%= _lcs( 'Noch keine Nutzungsdaten in diesem Zeitraum. Die Zahlen werden stündlich aus den Gäste-Apps verdichtet.' ) %></p>
  </div>
</section>
<% } else { %>

<section class="widget">
  <div class="widget__head">
    <h3 class="widget__title"><i class="icon icon--trending-up"></i> <%= lineTitle %></h3>
  </div>
  <div class="widget__body"><%- lineHtml %></div>
</section>

<section class="an-cols">
  <section class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--building-2"></i> <%= _lcs( 'Meistgenutzte Unterkünfte' ) %></h3>
    </div>
    <div class="widget__body widget__body--flush">
      <table class="an-table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col"><%= _lcs( 'Unterkunft' ) %></th>
            <th scope="col" class="an-table__num"><%= _lcs( 'Besucher' ) %></th>
            <th scope="col" class="an-table__num"><%= _lcs( 'Besuche' ) %></th>
            <th scope="col" class="an-table__num"><%= _lcs( 'Seitenaufrufe' ) %></th>
          </tr>
        </thead>
        <tbody>
          <% top.forEach( function( r ) { %>
          <tr>
            <td class="an-table__rank"><%= r.rank %></td>
            <td><span class="an-table__name"><%= r.name %></span><% if ( r.slug ) { %> <span class="an-table__slug"><%= r.slug %></span><% } %></td>
            <td class="an-table__num"><%= r.visitors %></td>
            <td class="an-table__num"><%= r.sessions %></td>
            <td class="an-table__num"><%= r.views %></td>
          </tr>
          <% } ); %>
        </tbody>
      </table>
    </div>
  </section>

  <section class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--layout-list"></i> <%= _lcs( 'Beliebteste Bereiche' ) %></h3>
    </div>
    <div class="widget__body">
      <% if ( hasAreas ) { %><%- areasHtml %><% } else { %><p class="an-muted"><%= _lcs( 'Noch keine Aufrufe.' ) %></p><% } %>
    </div>
  </section>
</section>

<section class="an-cols">
  <section class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--calendar-days"></i> <%= _lcs( 'Ø Besucher pro Wochentag' ) %></h3>
    </div>
    <div class="widget__body"><%- weekdayHtml %></div>
  </section>

  <section class="widget">
    <div class="widget__head">
      <h3 class="widget__title"><i class="icon icon--clock"></i> <%= _lcs( 'Besucher nach Uhrzeit' ) %></h3>
    </div>
    <div class="widget__body"><%- hourHtml %></div>
  </section>
</section>
<% } %>

<p class="an-foot">
  <%= _lcs( 'Anonym gezählt, ein Besucher je Tag und Unterkunft. Uhrzeit und Tag in der Zeitzone der jeweiligen Unterkunft.' ) %>
  <% if ( asOf ) { %> <%= _lcs( 'Stand: {date}', { date: asOf } ) %><% } %>
</p>
